import React, { Component } from 'react'

import { connect } from 'react-redux';
import { Field, reduxForm, change, reset } from 'redux-form';

import {
    GetDiagnosticReportFilter
} from '../../actions/diagnosticReportAction';

//Material ui components
import { Button, Grid, } from '@material-ui/core'
import Popover from '@material-ui/core/Popover';
import Slide from '@material-ui/core/Slide';

//engage Components
import {
    LegacySimpleSelect,
    renderActivityDatePicker
} from '../../utils/engageComponents';


const validate = (values) => {
};
export class DiagnosticFiltersDrawer extends Component {
    constructor(props) {
        super()
        this.state = {
            //filterObj
            filterObj: undefined,

            //Resident Filter
            openResidentFilterSelect: false,
            ResidentSelected: undefined,
            //Public Ip Filter
            openPublicIpFilterSelected: false,
            PublicIpSelected: undefined,
            //Unit Number Filter (Serial number)
            openUnitNumberFilterSelected: false,
            UnitNumberSelected: undefined,
            //Number Of Channels Filter
            openNumberChannelFilterSelected: false,
            NumberChannelSelected: undefined,
            // Measuring Lowest Filter
            openMeasuringLowestFilterSelected: false,
            MeasuringLowestSelected: undefined,
            // Measuring Highest Filter
            openMeasuringHighestFilterSelected: false,
            MeasuringHighestSelected: undefined,
            // Upload Speed Filter
            openUploadSpeedFilterSelected: false,
            uploadSpeedSelected: undefined,
            //Download Speed Filter
            onDownloadSpeedFilterSelected: false,
            downloadSpeedSelected: undefined,
            //Ssid On Off Filter
            onSsidOnOffFilterSelected: false,
            SsidOnOffSelected: undefined,
            //Docsis Filter
            onDocsisFilterSelected: false,
            DocsisSelected: undefined,
            //Mac Address Filter
            onMacAddressFilterSelected: false,
            MacAddressSelected: undefined,
            //Serial Filter
            onSerialFilterSelected: false,
            SerialSelected: undefined,
            //App Version Filter
            onAppVersionFilterSelected: false,
            AppVersionSelected: undefined,
            //Device Id
            onDeviceFilterSelected: false,
            DeviceSelected: undefined,
            //Signal Strength
            onSignalStrengthFilterSelected: false,
            SignalStrengthSelected: undefined,
            //Range Date
            dateChanged: (props.filterObj && (props.filterObj.startDateFilter || props.filterObj.endDateFilter)) ? true : false,
            StartDateSelected:  (props.filterObj && props.filterObj.startDateFilter)? props.filterObj.startDateFilter : new Date(),
            EndDateSelected: (props.filterObj && props.filterObj.endDateFilter)? props.filterObj.endDateFilter : new Date(),

        }

        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersResident', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersPublicIp', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersNumberChannel', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMeasuringLowest', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMeasuringHighest', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersUploadSpeed', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDownloadSpeed', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSsidOnOff', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDocsis', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMacAddress', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSerial', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersAppVersion', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDevice', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSignalStrength', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersStartDate', ''));
        props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersEndDate', ''));

    }

    componentDidMount = () => {
        window.addEventListener('resize', this.resize);

        if (this.props) {
            if (this.props.idAnchorEl) {
                this.setAnchorEl(this.props.idAnchorEl);
            }
        }

        const communityId = localStorage.getItem('communityId')

        this.props.GetDiagnosticReportFilter(communityId);
    };

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.resize);
    };

    resize = () => {
        if (this.props && this.props.idAnchorEl) {
            this.setAnchorEl(this.props.idAnchorEl)
        }
    };

    setAnchorEl(idAnchorEl) {
        const anchorEl = document.getElementById(idAnchorEl);

        if (anchorEl) {
            this.setState({ anchorEl: anchorEl })
        }
    };

    renderFilters(filterObj) {
        let residentSelected = undefined;
        let publicIpSelected = undefined;
        let unitNumberSelected = undefined;
        let numberChannelSelected = undefined;
        let measuringLowestSelected = undefined;
        let measuringHighestSelected = undefined;
        let uploadSpeedSelected = undefined;
        let downloadSpeedSelected = undefined;
        let ssidOnOffSelected = undefined;
        let docsisSelected = undefined;
        let macAddressSelected = undefined;
        let serialSelected = undefined;
        let appVersionSelected = undefined;
        let deviceSelected = undefined;
        let signalStrengthSelected = undefined;

        if (filterObj.ResidentFilter) {
            residentSelected = this.props.residentFilterData.find(item => item._id === filterObj.ResidentFilter);
        }
        if (filterObj.publicIpFilter) {
            publicIpSelected = this.props.publicIpFilterData.find(item => item === filterObj.publicIpFilter);
        }
        if (filterObj.unitNumberFilter) {
            unitNumberSelected = this.props.unitNumberFilterData.find(item => item === filterObj.unitNumberFilter);
        }
        if (filterObj.numberChannelFilter) {
            numberChannelSelected = this.props.numberOfChannelsFilterData.find(item => item === filterObj.numberChannelFilter);
        }
        if (filterObj.measuringLowestFilter) {
            measuringLowestSelected = this.props.measuringLowestFilterData.find(item => item === String(filterObj.measuringLowestFilter) + " dB");
        }
        if (filterObj.measuringHighestFilter) {
            measuringHighestSelected = this.props.measuringHighestFilterData.find(item => item === String(filterObj.measuringHighestFilter) + " dB");
        }
        if (filterObj.uploadSpeedFilter) {
            uploadSpeedSelected = this.props.uploadSpeedFilterData.find(item => item === String(filterObj.uploadSpeedFilter) + " Mbps");
        }
        if (filterObj.downloadSpeedFilter) {
            downloadSpeedSelected = this.props.downloadSpeedFilterData.find(item => item === String(filterObj.downloadSpeedFilter) + " Mbps");
        }
        if (filterObj.ssidOnOffFilter) {
            ssidOnOffSelected = this.props.ssidOnOffFilterData.find(item => item === filterObj.ssidOnOffFilter);
        }
        if (filterObj.docsisFilter) {
            docsisSelected = this.props.docsisFilterData.find(item => item === filterObj.docsisFilter);
        }
        if (filterObj.macAddressFilter) {
            macAddressSelected = this.props.macAddressFilterData.find(item => item === filterObj.macAddressFilter);
        }
        if (filterObj.serialFilter) {
            serialSelected = this.props.serialFilterData.find(item => item === filterObj.serialFilter);
        }
        if (filterObj.appVersionFilter) {
            appVersionSelected = this.props.appVersionFilterData.find(item => item === filterObj.appVersionFilter);
        }
        if (filterObj.deviceIdFilter) {
            deviceSelected = this.props.deviceFilterData.find(item => item === filterObj.deviceIdFilter);
        }
        if (filterObj.signalStrengthFilter) {
            signalStrengthSelected = this.props.signalStrengthFilterData.find(item => item.substring(0,1) === filterObj.signalStrengthFilter);
        }

        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersResident', residentSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersPublicIp', publicIpSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersNumberChannel', unitNumberSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMeasuringLowest', measuringLowestSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMeasuringHighest', measuringHighestSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersUploadSpeed', uploadSpeedSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDownloadSpeed', downloadSpeedSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSsidOnOff', ssidOnOffSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDocsis', docsisSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMacAddress', macAddressSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSerial', serialSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersAppVersion', appVersionSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDevice', deviceSelected));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSignalStrength', signalStrengthSelected));

        this.setState({
            ResidentSelected: residentSelected,
            PublicIpSelected: { name: publicIpSelected },
            UnitNumberSelected: { name: unitNumberSelected },
            NumberChannelSelected: { name: numberChannelSelected },
            MeasuringLowestSelected: { name: measuringLowestSelected },
            MeasuringHighestSelected: { name: measuringHighestSelected },
            UploadSpeedSelected: { name: uploadSpeedSelected },
            DownloadSpeedSelected: { name: downloadSpeedSelected },
            SsidOnOffSelected: { name: ssidOnOffSelected },
            DocsisSelected: { name: docsisSelected },
            MacAddressSelected: { name: macAddressSelected },
            SerialSelected: { name: serialSelected },
            AppVersionSelected: { name: appVersionSelected },
            DeviceSelected: { name: deviceSelected },
            SignalStrengthSelected: { name: signalStrengthSelected }
        });
    };


    //region Handlers
    handlerChangeOptionSelectedResidentName = (newResidentName) => {
        this.setState({ ResidentSelected: newResidentName })
    }

    handlerChangeOptionSelectedDevice = (newDevice) => {
        this.setState({ DeviceSelected: newDevice })
    }

    handlerChangeOptionSelectedPublicIp = (newPublicIpSelected) => {
        this.setState({ PublicIpSelected: newPublicIpSelected })
    }

    handlerChangeOptionSelectedUnitNumber = (newUnitNumberSelected) => {
        this.setState({ UnitNumberSelected: newUnitNumberSelected })
    }

    handlerChangeOptionSelectedNumberOfChannels = (newNumberChannelSelected) => {
        this.setState({ NumberChannelSelected: newNumberChannelSelected })
    }

    handlerChangeOptionSelectedMeasuringLowest = (newMeasuringLowestSelected) => {
        this.setState({ MeasuringLowestSelected: newMeasuringLowestSelected })
    }

    handlerChangeOptionSelectedMeasuringHighest = (newMeasuringHighestSelected) => {
        this.setState({ MeasuringHighestSelected: newMeasuringHighestSelected })
    }

    handlerChangeOptionSelectedUploadSpeed = (newUploadSpeedSelected) => {
        this.setState({ UploadSpeedSelected: newUploadSpeedSelected })
    }

    handlerChangeOptionSelectedDownloadSpeed = (newDownloadSpeedSelected) => {
        this.setState({ DownloadSpeedSelected: newDownloadSpeedSelected })
    }

    handlerChangeOptionSelectedSsidOnOff = (newSsidOnOffSelected) => {
        this.setState({ SsidOnOffSelected: newSsidOnOffSelected })
    }

    handlerChangeOptionSelectedDocsis = (newDocsisSelected) => {
        this.setState({ DocsisSelected: newDocsisSelected })
    }

    handlerChangeOptionSelectedMacAddress = (newMacAddressSelected) => {
        this.setState({ MacAddressSelected: newMacAddressSelected })
    }

    handlerChangeOptionSelectedSerial = (newSerialSelected) => {
        this.setState({ SerialSelected: newSerialSelected })
    }

    handlerChangeOptionSelectedAppVersion = (newAppVersionSelected) => {
        this.setState({ AppVersionSelected: newAppVersionSelected })
    }

    handlerChangeOptionSelectedSignalStrength = (newSignalStrengthSelected) => {
        this.setState({ SignalStrengthSelected: newSignalStrengthSelected })
    }


    handlerCleanFilters = () => {
        this.props.onFilterChange({});

        this.setState({
            //filterObj
            filterObj: undefined,

            //Resident Filter
            openResidentFilterSelect: false,
            ResidentSelected: undefined,
            //Public Ip Filter
            openPublicIpFilterSelected: false,
            PublicIpSelected: undefined,
            //Unit Number Filter (Serial number)
            openUnitNumberFilterSelected: false,
            UnitNumberSelected: undefined,
            //Number Of Channels Filter
            openNumberChannelFilterSelected: false,
            NumberChannelSelected: undefined,
            // Measuring Lowest Filter
            openMeasuringLowestFilterSelected: false,
            MeasuringLowestSelected: undefined,
            // Measuring Highest Filter
            openMeasuringHighestFilterSelected: false,
            MeasuringHighestSelected: undefined,
            //Download Speed Filter
            onDownloadSpeedFilterSelected: false,
            downloadSpeedSelected: undefined,
            //Ssid On Off Filter
            onSsidOnOffFilterSelected: false,
            SsidOnOffSelected: undefined,
            //Docsis Filter
            onDocsisFilterSelected: false,
            DocsisSelected: undefined,
            //Mac Address Filter
            onMacAddressFilterSelected: false,
            MacAddressSelected: undefined,
            //Serial Filter
            onSerialFilterSelected: false,
            SerialSelected: undefined,
            //App Version Filter
            onAppVersionFilterSelected: false,
            AppVersionSelected: undefined,
            newFilterObj: undefined,
            // Device Filter
            onDeviceFilterSelected : false,
            deviceSelected : undefined,
            // Signal Strength
            onSignalStrengthSelected: false,
            signalStrengthSelected : undefined,
            // DateRange
            startDateSelcted: undefined,
            endDateSelected: undefined
        });

        this.props.dispatch(reset('DiagnosticFiltersDrawerForm'));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersResident', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersPublicIp', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersNumberChannel', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMeasuringLowest', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMeasuringHighest', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersUploadSpeed', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDownloadSpeed', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSsidOnOff', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDocsis', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersMacAddress', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSerial', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersAppVersion', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersDevice', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersSignalStrength', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersStartDate', ''));
        this.props.dispatch(change('DiagnosticFiltersDrawerForm', 'FiltersEndDate', ''));
    }

    onSubmitHandler = (form) => {
        this.handlerCleanFilters();
    }

    handleApplyFilters = () => {
        try {
            const newFilters = {
                ResidentFilter: (this.state.ResidentSelected && this.state.ResidentSelected._id) ? this.state.ResidentSelected._id : undefined,
                publicIpFilter: (this.state.PublicIpSelected && this.state.PublicIpSelected.name) ? this.state.PublicIpSelected.name : undefined,
                unitNumberFilter: (this.state.UnitNumberSelected && this.state.UnitNumberSelected.name) ? this.state.UnitNumberSelected.name : undefined,
                numberChannelFilter: (this.state.NumberChannelSelected && this.state.NumberChannelSelected.name) ? this.state.NumberChannelSelected.name : undefined,
                measuringLowestFilter: (this.state.MeasuringLowestSelected && this.state.MeasuringLowestSelected.name) ? this.state.MeasuringLowestSelected.name.replace(' dB', '') : undefined,
                measuringHighestFilter: (this.state.MeasuringHighestSelected && this.state.MeasuringHighestSelected.name) ? this.state.MeasuringHighestSelected.name.replace(' dB', '') : undefined,
                uploadSpeedFilter: (this.state.UploadSpeedSelected && this.state.UploadSpeedSelected.name) ? this.state.UploadSpeedSelected.name.replace(' Mbps', '') : undefined,
                downloadSpeedFilter: (this.state.DownloadSpeedSelected && this.state.DownloadSpeedSelected.name) ? this.state.DownloadSpeedSelected.name.replace(' Mbps', '') : undefined,
                ssidOnOffFilter: (this.state.SsidOnOffSelected && this.state.SsidOnOffSelected.name) ? this.state.SsidOnOffSelected.name : undefined,
                docsisFilter: (this.state.DocsisSelected && this.state.DocsisSelected.name) ? this.state.DocsisSelected.name : undefined,
                macAddressFilter: (this.state.MacAddressSelected && this.state.MacAddressSelected.name) ? this.state.MacAddressSelected.name : undefined,
                serialFilter: (this.state.SerialSelected && this.state.SerialSelected.name) ? this.state.SerialSelected.name : undefined,
                appVersionFilter: (this.state.AppVersionSelected && this.state.AppVersionSelected.name) ? this.state.AppVersionSelected.name : undefined,
                signalStrengthFilter: (this.state.SignalStrengthSelected && this.state.SignalStrengthSelected.name) ? this.state.SignalStrengthSelected.name.substring(0,1) : undefined,
                deviceIdFilter: (this.state.DeviceSelected && this.state.DeviceSelected.name) ? this.state.DeviceSelected.name : undefined,
                startDateFilter : (this.state.StartDateSelected && this.state.dateChanged) ? this.state.StartDateSelected : undefined,
                endDateFilter : (this.state.EndDateSelected && this.state.dateChanged) ? this.state.EndDateSelected : undefined,
            }
            this.props.onFilterChange(newFilters)
        } catch (err) {
            return err;
        }
    }
    //#endregion

    //#region INNER COMPONENTS
    // onClick={}
    ApplyFilterComponent = () => {
        const handleSubmit = this.props.handleSubmit;
        return (
            <Grid item container xs={12} justify='center' alignContent='center'>
                <Grid item container xs={12} >
                    <Button className="filters_btn" onClick={this.handleApplyFilters}>Apply Current Filters</Button>
                    <Button className={this.props.isLegacy ? 'Lfilters_clear_btn' : 'filters_clear_btn'} onClick={handleSubmit(this.onSubmitHandler.bind(this))}>Clear All</Button>
                </Grid>
            </Grid>
        )
    }

    FiltersConponent = () => {
        const styles = {
            container: {
            },
            filterContainer: {
                marginTop: '35px',
                borderRadius: '15px',
                border: '1px solid #707070'
            },
            spaceFillerContainer: {
                height: '200px'
            },
            resetFiltersContainer: {
                padding: '25px',
                position: 'relative',
                bottom: '0px'
            }
        }

        return (
            <Grid id='diagnosticFiltersDrawer' item container className='popOverFilterContainer' alignContent='flex-start' justify='center' style={{ position: 'absolute' }}>
                <Grid item container>
                    <this.TitleComponent />
                </Grid>
                {/*<Grid item container style={{ ...styles.filterContainer }}>
                    <this.UnitNumberFilterComponent />
                </Grid>*/}
                <Grid item container>
                    <this.DateRangeComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.ResidentNameFiltersComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.DeviceFiltersComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.MeasuringLowestFilterComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.MeasuringHighestFilterComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.DownloadSpeedTestFilterComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.UploadSpeedTestFilterComponent />
                </Grid>
                {/*<Grid item container style={{ ...styles.filterContainer }}>
                    <this.DocsisFilterComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.MacAddressFilterComponent />
                </Grid>*/}
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.SerialFilterComponent />
                </Grid>
                <Grid item container style={{ ...styles.filterContainer }}>
                    <this.SignalStrengthFilterComponent />
                </Grid>
                <Grid item container xs={12} style={{ ...styles.resetFiltersContainer }}>
                    <this.ApplyFilterComponent />
                </Grid>

            </Grid>
        );
    };

    TitleComponent = () => {
        return (
            <Grid item container>
                <Grid item className={this.props.newStyles ? 'LpopOverFiltersTitle_V2' : this.props.isLegacy ? 'LpopOverFiltersTitle' : 'popOverFiltersTitle'}>Filters</Grid>
            </Grid>);
    };

    ResidentNameFiltersComponent = () => {
        //This 3 const are for eliminate the duplicate elements in names 
        const residents = this.props.residentFilterData ? [...this.props.residentFilterData] : []

        const residentsFiltered = [...new Set(residents)]

        const residentSelected = this.state.ResidentSelected ? this.state.ResidentSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => { this.setState({ openResidentFilterSelect: false }); }}
                onClick={() => { this.setState((prevState) => ({ openResidentFilterSelect: !prevState.openResidentFilterSelect })); }} >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_residents'
                    showLabel={true}
                    label={'Resident'}
                    open={this.state.openResidentFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedResidentName(newItem)}
                    optionsItemsIconsData={residentsFiltered}
                    selected={residentSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={true}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    DeviceFiltersComponent = () => {
        //This 3 const are for eliminate the duplicate elements in names 
        const devices = this.props.deviceFilterData ? [...this.props.deviceFilterData] : []

        const devicesFiltered = [...new Set(devices)]

        const devicesArr = devicesFiltered.map(item => ({ name: item }))

        const deviceSelected = this.state.DeviceSelected ? this.state.DeviceSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => { this.setState({ openDeviceFilterSelect: false }); }}
                onClick={() => { this.setState((prevState) => ({ openDeviceFilterSelect: !prevState.openDeviceFilterSelect })); }} >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_devices'
                    showLabel={true}
                    label={'Device'}
                    open={this.state.openDeviceFilterSelect}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedDevice(newItem)}
                    optionsItemsIconsData={devicesArr}
                    selected={deviceSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={true}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    DateRangeComponent = () => {
        return (
            <Grid item container xs={12} justifyContent='space-between'>
                <Grid item xs={12} className='filters_subtitles sectionMargin legacyDiagnosticFiltersDrawer_daterange-label'>Date Range</Grid>

                {/* Date range */}
                <Grid item className={!this.state.dateChanged ? 'Ldate_range_box' : 'Ldate_range_box_selected'}>
                    <Field
                        name="startDate"
                        labelDate="From"
                        selectedDate={this.state.StartDateSelected} //most be an date object is use in both date and time
                        onDateChange={(date) => this.setState({ StartDateSelected : date, dateChanged : true })}
                        maxLength={20}
                        component={renderActivityDatePicker}
                        idToSet='legacyDiagnosticFiltersDrawer_startDate'
                        id='legacyDiagnosticFiltersDrawer_startDate'
                        active={!this.state.dateOptionSelected}
                        isLegacy={true}
                    />
                </Grid>

                <Grid item className={!this.state.dateChanged ? 'Ldate_range_box' : 'Ldate_range_box_selected'}>
                    <Field
                        name="endDate"
                        labelDate="To"
                        selectedDate={this.state.EndDateSelected} //most be an date object is use in both date and time
                        onDateChange={(date) => this.setState({ EndDateSelected : date, dateChanged : true })}
                        maxLength={20}
                        component={renderActivityDatePicker}
                        idToSet='legacyDiagnosticFiltersDrawer_endDate'
                        id='legacyDiagnosticFiltersDrawer_endDate'
                        active={!this.state.dateOptionSelected}
                        isLegacy={true}
                    />
                </Grid>
            </Grid>
        );
    };

    PublicIpFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const ips = this.props.publicIpFilterData ? [...this.props.publicIpFilterData] : []

        const ipsFiltered = [...new Set(ips)]

        const ipsArr = ipsFiltered.map(item => ({ name: item }))

        const publicIpSelected = this.state.PublicIpSelected ? this.state.PublicIpSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ openPublicIpFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ openPublicIpFilterSelected: !prevState.openPublicIpFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_publicip'
                    showLabel={true}
                    label={'Public Ip'}
                    open={this.state.openPublicIpFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionPublicIp(newItem)}
                    optionsItemsIconsData={ipsArr}
                    selected={publicIpSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    UnitNumberFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const unitNumbers = this.props.unitNumberFilterData ? [...this.props.unitNumberFilterData] : []

        const unitNumbersFiltered = [...new Set(unitNumbers)]

        const unitNumbersArr = unitNumbersFiltered.map(item => ({ name: item }))

        const unitNumberSelected = this.state.UnitNumberSelected ? this.state.UnitNumberSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ openUnitNumberFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ openUnitNumberFilterSelected: !prevState.openUnitNumberFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_unitnumbers'
                    showLabel={true}
                    label={'Unit Number'}
                    open={this.state.openUnitNumberFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedUnitNumber(newItem)}
                    optionsItemsIconsData={unitNumbersArr}
                    selected={unitNumberSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    NumberChannelsFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const numberChannels = this.props.numberOfChannelsFilterData ? [...this.props.numberOfChannelsFilterData] : []

        const numberChannelsFiltered = [...new Set(numberChannels)]

        const numberChannelsArr = numberChannelsFiltered.map(item => ({ name: item }))

        const numberChannelSelected = this.state.NumberChannelSelected ? this.state.NumberChannelSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ openNumberChannelFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ openNumberChannelFilterSelected: !prevState.openNumberChannelFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_numberchannels'
                    showLabel={true}
                    label={'Number Channels'}
                    open={this.state.numberChannelFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedNumberOfChannels(newItem)}
                    optionsItemsIconsData={numberChannelsArr}
                    selected={numberChannelSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    MeasuringLowestFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const measuringLowests = this.props.measuringLowestFilterData ? [...this.props.measuringLowestFilterData] : []

        const measuringLowestsFiltered = [...new Set(measuringLowests)]

        const measuringLowestsArr = measuringLowestsFiltered.map(item => ({ name: item }))

        const measuringLowestSelected = this.state.MeasuringLowestSelected ? this.state.MeasuringLowestSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ openMeasuringLowestFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ openMeasuringLowestFilterSelected: !prevState.openMeasuringLowestFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_measuringlowest'
                    showLabel={true}
                    label={'Measuring Lowest'}
                    open={this.state.openMeasuringLowestFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedMeasuringLowest(newItem)}
                    optionsItemsIconsData={measuringLowestsArr}
                    selected={measuringLowestSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    MeasuringHighestFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const measuringHighests = this.props.measuringHighestFilterData ? [...this.props.measuringHighestFilterData] : []

        const measuringHighestsFiltered = [...new Set(measuringHighests)]

        const measuringHighestsArr = measuringHighestsFiltered.map(item => ({ name: item }))

        const measuringHighestSelected = this.state.MeasuringHighestSelected ? this.state.MeasuringHighestSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ openMeasuringHighestFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ openMeasuringHighestFilterSelected: !prevState.openMeasuringHighestFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_measuringhighest'
                    showLabel={true}
                    label={'Measuring Highest'}
                    open={this.state.openMeasuringHighestFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedMeasuringHighest(newItem)}
                    optionsItemsIconsData={measuringHighestsArr}
                    selected={measuringHighestSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    UploadSpeedTestFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const uploadSpeeds = this.props.uploadSpeedFilterData ? [...this.props.uploadSpeedFilterData] : []

        const uploadSpeedsFiltered = [...new Set(uploadSpeeds)]

        const uploadSpeedsArr = uploadSpeedsFiltered.map(item => ({ name: item }))

        const uploadSpeedSelected = this.state.UploadSpeedSelected ? this.state.UploadSpeedSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ openUploadSpeedFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ openUploadSpeedFilterSelected: !prevState.openUploadSpeedFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_uploadspeed'
                    showLabel={true}
                    label={'Upload Speed'}
                    open={this.state.openUploadSpeedFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedUploadSpeed(newItem)}
                    optionsItemsIconsData={uploadSpeedsArr}
                    selected={uploadSpeedSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    DownloadSpeedTestFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const downloadSpeeds = this.props.downloadSpeedFilterData ? [...this.props.downloadSpeedFilterData] : []

        const downloadSpeedsFiltered = [...new Set(downloadSpeeds)]

        const downloadSpeedsArr = downloadSpeedsFiltered.map(item => ({ name: item }))

        const downloadSpeedSelected = this.state.DownloadSpeedSelected ? this.state.DownloadSpeedSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ onDownloadSpeedFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ onDownloadSpeedFilterSelected: !prevState.onDownloadSpeedFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_downloadspeed'
                    showLabel={true}
                    label={'Download Speed'}
                    open={this.state.onDownloadSpeedFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedDownloadSpeed(newItem)}
                    optionsItemsIconsData={downloadSpeedsArr}
                    selected={downloadSpeedSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    SsidOnOffFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const ssidOnOffs = this.props.ssidOnOffFilterData ? [...this.props.ssidOnOffFilterData] : []

        const ssidOnOffsFiltered = [...new Set(ssidOnOffs)]

        const ssidOnOffsArr = ssidOnOffsFiltered.map(item => ({ name: item }))

        const ssidOnOffSelected = this.state.SsidOnOffSelected ? this.state.SsidOnOffSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ onSsidOnOffFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ onSsidOnOffFilterSelected: !prevState.onSsidOnOffFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_ssidonoff'
                    showLabel={true}
                    label={'SSID ON OFF'}
                    open={this.state.onSsidOnOffFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedSsidOnOff(newItem)}
                    optionsItemsIconsData={ssidOnOffsArr}
                    selected={ssidOnOffSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    DocsisFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const docsiss = this.props.docsisFilterData ? [...this.props.docsisFilterData] : []

        const docsissFiltered = [...new Set(docsiss)]

        const docsissArr = docsissFiltered.map(item => ({ name: item }))

        const docsisSelected = this.state.DocsisSelected ? this.state.DocsisSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ onDocsisFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ onDocsisFilterSelected: !prevState.onDocsisFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_docsis'
                    showLabel={true}
                    label={'Docsis'}
                    open={this.state.onDocsisFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedDocsis(newItem)}
                    optionsItemsIconsData={docsissArr}
                    selected={docsisSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    MacAddressFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const macAddresss = this.props.macAddressFilterData ? [...this.props.macAddressFilterData] : []

        const macAddresssFiltered = [...new Set(macAddresss)]

        const macAddresssArr = macAddresssFiltered.map(item => ({ name: item }))

        const macAddressSelected = this.state.MacAddressSelected ? this.state.MacAddressSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ onMacAddressFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ onMacAddressFilterSelected: !prevState.onMacAddressFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_macaddress'
                    showLabel={true}
                    label={'Mac Address'}
                    open={this.state.onMacAddressFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedMacAddress(newItem)}
                    optionsItemsIconsData={macAddresssArr}
                    selected={macAddressSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    SerialFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const serials = this.props.serialFilterData ? [...this.props.serialFilterData] : []

        const serialsFiltered = [...new Set(serials)]

        const serialsArr = serialsFiltered.map(item => ({ name: item }))

        const serialSelected = this.state.SerialSelected ? this.state.SerialSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ onSerialFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ onSerialFilterSelected: !prevState.onSerialFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_serial'
                    showLabel={true}
                    label={'Serial'}
                    open={this.state.onSerialFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedSerial(newItem)}
                    optionsItemsIconsData={serialsArr}
                    selected={serialSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    AppVersionFilterComponent = () => {

        //This 3 const are for eliminate the duplicate items of zones 
        const appVersions = this.props.appVersionFilterData ? [...this.props.appVersionFilterData] : []

        const appVersionsFiltered = [...new Set(appVersions)]

        const appVersionsArr = appVersionsFiltered.map(item => ({ name: item }))

        const appVersionSelected = this.state.AppVersionSelected ? this.state.AppVersionSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ onAppVersionFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ onAppVersionFilterSelected: !prevState.onAppVersionFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_appversion'
                    showLabel={true}
                    label={'App Version'}
                    open={this.state.onAppVersionFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedAppVersion(newItem)}
                    optionsItemsIconsData={appVersionsArr}
                    selected={appVersionSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    SignalStrengthFilterComponent = () => {

        const signalStrengths = this.props.signalStrengthFilterData ? [...this.props.signalStrengthFilterData] : []

        const signalStrengthsFiltered = [...new Set(signalStrengths)]

        const signalStrengthsArr = signalStrengthsFiltered.map(item => ({ name: item }))

        const signalStrengthSelected = this.state.SignalStrengthSelected ? this.state.SignalStrengthSelected : {};

        return (
            <Grid item
                xs={12}
                style={{ paddingLeft: '15px', marginRight: '15px' }}
                justify='center'
                onBlur={() => this.setState({ onSignalStrengthFilterSelected: false })}
                onClick={() => this.setState((prevState) => ({ onSignalStrengthFilterSelected: !prevState.onSignalStrengthFilterSelected }))}
            >
                <LegacySimpleSelect
                    idToSet='legacyDiagnosticFiltersDrawer_signalstrength'
                    showLabel={true}
                    label={'Signal Strength'}
                    open={this.state.onSignalStrengthFilterSelected}
                    onChangeHandler={(evet, newItem) => this.handlerChangeOptionSelectedSignalStrength(newItem)}
                    optionsItemsIconsData={signalStrengthsArr}
                    selected={signalStrengthSelected}
                    disabled={false}
                    error={undefined}
                    helperText={undefined}
                    autoFocus={false}
                    stylesObj={{ underline: 'noBorderStyle' }}
                />
            </Grid>
        );
    };

    ResetFiltersComponent = () => {
        const handleSubmit = this.props.handleSubmit;
        return (
            <Button
                id='diagnosticFiltersDrawer_resetbtn'
                className='appbtn-engage skybluebtn-engage appbtnBarButton textTransform'
                onClick={handleSubmit(this.onSubmitHandler.bind(this))}
            >
                Reset
            </Button>
        );
    }
    //#endregion

    render() {
        if (this.props.filterObj !== this.state.filterObj) {
            this.setState({ filterObj: this.props.filterObj ? this.props.filterObj : {} }, () => {
                this.renderFilters(this.props.filterObj);
            })
        }

        return (
            <>
                {
                    this.state.anchorEl ?
                        <Popover
                            id="ActivityFilterPopOver"
                            open={true}
                            onClose={this.props.onClose}
                            anchorEl={this.state.anchorEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}

                            PaperProps={{
                                className: 'LpopOverFilter',
                            }}
                            elevation={0}
                        >
                            <Slide in={true} direction='left' timeout={600} mountOnEnter unmountOnExit>
                                <Grid className={this.props.newStyles ? 'LpopOverFilterSlide_V2' : this.props.isLegacy ? 'LpopOverFilterSlideDiag' : 'popOverFilterSlide'} style={{ height: '100%' }}>
                                    <form>
                                        <this.FiltersConponent />
                                    </form>
                                </Grid>
                            </Slide>
                        </Popover>
                        :
                        undefined
                }

            </>
        )
    }
}

function mapStateToProps(state) {
    const filters = (state.diagnosticReportReducer && state.diagnosticReportReducer.filters) ? state.diagnosticReportReducer.filters : {};

    return {
        residentFilterData: filters.residents ? filters.residents : [],
        publicIpFilterData: filters.publicIp ? filters.publicIp : [],
        unitNumberFilterData: filters.unitNumber ? filters.unitNumber : [],
        numberOfChannelsFilterData: filters.numberOfChannels ? filters.numberOfChannels : [],
        measuringLowestFilterData: filters.measuringLowest ? filters.measuringLowest : [],
        measuringHighestFilterData: filters.measuringHighest ? filters.measuringHighest : [],
        uploadSpeedFilterData: filters.uploadSpeed ? filters.uploadSpeed : [],
        downloadSpeedFilterData: filters.downloadSpeed ? filters.downloadSpeed : [],
        ssidOnOffFilterData: filters.ssidOnOff ? filters.ssidOnOff : [],
        docsisFilterData: filters.docsis ? filters.docsis : [],
        macAddressFilterData: filters.macAddress ? filters.macAddress : [],
        serialFilterData: filters.serial ? filters.serial : [],
        appVersionFilterData: filters.appVersion ? filters.appVersion : [],
        signalStrengthFilterData: filters.signalStrength ? filters.signalStrength : [],
        deviceFilterData: filters.deviceId ? filters.deviceId : []
    };
};

export default connect(mapStateToProps, { GetDiagnosticReportFilter })(reduxForm({
    form: 'DiagnosticFiltersDrawerForm',
    validate,
})(DiagnosticFiltersDrawer));
